import isExperienceEditor from "@utils/is-experience-editor";

let VCA = VCA || {};

VCA.HospitalThreeCardCarousel = (function ($) {
    let ui = {};
    let MEDIA_QUERY = '(max-width: 991px)';
    let mql = window.matchMedia(MEDIA_QUERY);
    let isExperienceEditor = $('#sitecore-page-mode').attr('data-attribute');

    function cacheUI() {
        ui.$body = $('body');
        ui.$cardSlider = $('.js-card-slider');
    }

    function initCarouselSlider(e) {
        var cardSlider = ui.$cardSlider.each(function (index, element) {
            $(this).addClass('js-card-slider' + index);
            var item_length = $('.js-card-slider' + index + ' > div').length;
            if (item_length > 3 && !isExperienceEditor) {
                $('.js-card-slider' + index).slick({
                    autoplay: false,
                    infinite: false,
                    arrows: true,
                    dots: false,
                    slidesToShow: 3,
                    rows: 0,
                    slidesToScroll: 1,
                    draggable: false,
                    responsive: [{
                            breakpoint: 1280,
                            settings: {
                                slidesToShow: 3,
                                dots: true,
                                arrows: false,
                                accessibility: true,
                                draggable: true
                            }
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2,
                                dots: true,
                                arrows: false,
                                focusOnChange: true,
                                accessibility: true,
                                draggable: true
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                dots: true,
                                arrows: false,
                                focusOnChange: true,
                                accessibility: true,
                                draggable: true
                            }
                        }
                    ]
                });
            } else if (mql.matches && item_length > 1 && !isExperienceEditor) {
                $('.js-card-slider' + index).slick({
                    autoplay: false,
                    infinite: false,
                    arrows: false,
                    dots: false,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    rows: 0,
                    draggable: false,
                    responsive: [{
                            breakpoint: 1024,
                            settings: "unslick"
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                                dots: true,
                                arrows: false,
                                focusOnChange: true,
                                accessibility: true,
                                draggable: true
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: true,
                                arrows: false,
                                focusOnChange: true,
                                accessibility: true,
                                draggable: true
                            }
                        }
                    ]
                });
            }
        });
    }

    function init() {
        cacheUI();
        initCarouselSlider();
    }

    return {
       init: init
    };

})(jQuery);

$(function () {
    VCA.HospitalThreeCardCarousel.init();
});